export default "__VITE_ASSET__1e84f72b__"